import { createSelector } from 'reselect';
import { getLegalEntities } from 'selectors/entities/legalEntitiesSelectors';
import { getAllUsers } from 'selectors/entities/userSelectors';
// Returns all clients from state
export const getClients = (state) => state.getIn(['entities', 'client', 'clients']);

// Returns client by specified id
export const getClientById = (state, { companyId }) => state.getIn(['entities', 'client', 'clients', companyId]);

// Return invoices
export const getClientPayments = (state, props = {}) =>
  state.getIn(['entities', 'client', 'clientPayments']).filter((invoice) => {
    const search = props.search;
    if (!search) {
      return true;
    } else {
      const value =
        invoice.get('projectName') +
        invoice.get('clientName') +
        invoice.get('paymentOption') +
        invoice.get('amount') +
        invoice.get('paymentDate');
      return value?.toLowerCase()?.indexOf(search.toLowerCase()) !== -1;
    }
  });

// Return invoice by id
export const getClientPaymentById = (state, props = {}) =>
  state.getIn(['entities', 'client', 'clientPayments', props.invoiceId]);

// Return team profiles
export const getClientTeamProfiles = (state, { team }) => {
  return team.map((id) => state.getIn(['entities', 'user', 'clientProfiles', id]));
};

// Return invoices
export const getClientInvoices = (state) => state.getIn(['entities', 'client', 'clientInvoices']);

export const getClientInvoiceById = (state, { invoiceId }) =>
  state.getIn(['entities', 'client', 'clientInvoices', invoiceId]);

export const getClientInvoiceByIdWithSymmary = createSelector(
  [getClientInvoiceById, getLegalEntities],
  (invoice, legalEntities) => {
    return invoice?.set('clientEntity', legalEntities?.get(invoice?.get('clientEntityId')));
  },
);

export const getClientInvoicesIdWithSymmary = createSelector([getClientInvoices, getAllUsers], (invoices, users) => {
  return invoices.map((invoice) => invoice?.set('creator', users?.get(invoice?.get('creatorId'))));
});
